import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorMessageWithRetry = ({
  retry,
  title
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    use: "inline",
    type: "danger",
    titleText: title,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "routing-ui.shared.alerts.RETRY.message_jsx",
      options: {
        onClick: retry,
        underline: true,
        use: 'on-bright'
      },
      elements: {
        UILink
      }
    })
  });
};
ErrorMessageWithRetry.displayName = 'ErrorMessageWithRetry';
export default ErrorMessageWithRetry;